export default __webpack_public_path__ + "8481feabbe8970ae33c1bd1395357d2c.jpg";